import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import { Divider, DatePicker } from 'rsuite';
import { useAuth } from '../../AuthContext';
import FolderIcon from '@rsuite/icons/Folder';
import { BsCalendar2MonthFill } from 'react-icons/bs';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';

function AdminDashboard() {
  const { auth } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate

  const [selectedDate, setSelectedDate] = useState(new Date());

  const [newOrders, setNewOrders] = useState(0);
  const [handledOrders, setHandledOrders] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [marginal, setMarginal] = useState(0);

  const fetchData = async () => {
    if (!(selectedDate instanceof Date) || isNaN(selectedDate)) {
      toast.error('Ogiltigt datum. Vänligen välj ett giltigt datum.', {
        position: 'bottom-right'
      });
      return;
    }
  
    const formattedDate = selectedDate.toISOString().split('T')[0];  // Format: YYYY-MM-DD
  
    setLoading(true);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/dashboard/info?date=${formattedDate}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`
        }
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Misslyckades att hämta information: ${errorText}`);
      }
  
      const data = await response.json();
  
      // ✅ Update state variables
      setNewOrders(data.newOrders);
      setHandledOrders(data.handledOrders);
      setRevenue(data.revenue);
      setMarginal(data.marginal);
  
    } catch (error) {
      console.error("Error fetching info:", error.message);
      toast.error(error.message, {
        position: 'bottom-right'
      });
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
      fetchData();
      }, [selectedDate]);

  return (
    <>
        <Helmet>
          <title>{`Översikt`}</title>
        </Helmet>
        <div className='px-5 pt-4 w-100'>
        <h4 className="mb-2">Välkommen Tillbaka, {auth.firstName} 👋</h4>
        <p className="text-muted mb-1">Här är din översikt. Välj månad för att se statistik</p>
        <DatePicker
          format="MMM yyyy"
          caretAs={BsCalendar2MonthFill}
          value={selectedDate}  // Bind the value to selectedDate
          onChange={(value) => setSelectedDate(value)}  // Update the state on change
          placeholder="Select month and year"
        />
        <hr />
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-4 mb-2">
            <div className="card shadow p-3">
              <div className="d-flex align-items-center">
                  <FolderIcon className='me-2' />
                  <p className='mb-0'>Nya delticom ordrar</p>
              </div>
              <h3 className='mb-0'>
                {newOrders} ST
              </h3>
            </div>
          </div>

          <div className="col-sm-12 col-md-12 col-lg-4 mb-2">
            <div className="card shadow p-3">
              <div className="d-flex align-items-center">
                  <FolderIcon className='me-2' />
                  <p className='mb-0'>Färdiga delticom ordrar</p>
              </div>
              <h3 className='mb-0'>
                {handledOrders} ST
              </h3>
            </div>
          </div>

          <div className="col-sm-12 col-md-12 col-lg-4 mb-2">
            <div className="card shadow p-3">
              <div className="d-flex align-items-center">
                  <FolderIcon className='me-2' />
                  <p className='mb-0'>Omsättning (ink moms)</p>
              </div>
              <h3 className='mb-0'>
                {new Intl.NumberFormat('sv-SE', {
                  style: 'decimal',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(revenue)} SEK
              </h3>

            </div>
          </div>

          <div className="col-sm-12 col-md-12 col-lg-4 mb-2">
            <div className="card shadow bg-success-subtle p-3">
              <div className="d-flex align-items-center">
                  <FolderIcon className='me-2' />
                  <p className='mb-0'>Ungefärlig marginal</p>
              </div>
              <h3 className='mb-0'>
                {new Intl.NumberFormat('sv-SE', {
                  style: 'decimal',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(marginal)} SEK
              </h3>
            </div>
          </div>
          
        </div>

        </div>
    </>
  );
}

export default AdminDashboard;
